import { INDIVIDUAL_OPTIONS } from "../_constants/individualOptionsFields.constant";

const initialState = {
    initialFieldsList: {
        allFields: []
    },
}

export function individualFieldsReducer(state = initialState, action) {
  switch (action.type) {
    case INDIVIDUAL_OPTIONS.SET_FIELDS:{
      return {
        ...state,
        initialFieldsList: {
          ...state.initialFieldsList,
          allFields: action.data.fields,
        },
      };
    }
    case INDIVIDUAL_OPTIONS.CLEAR_FIELDS: {
      return initialState;
    }
 
    default:
      return state
  }
}
